import React from 'react'

const Select = ({field, validate}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  let options = field.filteredOptions ? field.filteredOptions : field.options;

  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="col-form-label col-form-label-sm">{field.rules.title}</label>
      <select
        className={hasErrors ? 'form-control form-control-sm is-invalid' : 'form-control form-control-sm'}
        name={field.name}
        value={field.value == '' ? field.defaultValue: field.value}
        disabled={field.disabled ? true : null}
        onChange={e => validate(e.target.value, field)}>
        {field.placeholder &&
          <option value="">{field.placeholder}</option>
        }
        {options.map((option, i) => {
          if (option instanceof Object){
            return (
              <option key={i} value={option.value}>
                {option.label}
              </option>
            )
          }
          else {
            return (
              <option key={i} value={option}>
                {option}
              </option>
            )
          }
        })}
      </select>
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (Select)
